
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const LoginPrompt = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <div className="container max-w-4xl mx-auto px-4 py-8 md:py-16">
      <div className="text-center space-y-6">
        <h1 className="text-2xl md:text-3xl font-bold">{t('creator.welcome')}</h1>
        <p className="text-lg md:text-xl text-muted-foreground">
          {t('creator.pleaseLogin')}
        </p>
        <div className="flex flex-col md:flex-row justify-center gap-4">
          <Button onClick={() => navigate("/auth/login")} className="w-full md:w-auto">{t('nav.login')}</Button>
        </div>
      </div>
    </div>
  );
};

export default LoginPrompt;
